/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs */



/**
* | output |
* | --- |
* | "Shift a single word back to the end of the previous Event" |
*
* @param {Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_word_to_previous_event = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Word_To_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer un mot vers la fin de l'evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschiebe ein einzelnes Wort an das Ende des vorherigen Ereignisses.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta una singola parola alla fine dell'evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвинуть на одно слово назад, в конец предыдущего события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar una sola palabra al final del evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将一个词移回上一个事件的末尾")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1つの単語を前のイベントの末尾に戻します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक शब्द को पिछले इवेंट के अंत में ले जाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desloque uma única palavra para o final do evento anterior.")
	return /** @type {LocalizedString} */ ("Shift a single word back to the end of the previous Event")
});